import { render, staticRenderFns } from "./FollowAccount.vue?vue&type=template&id=34266906&scoped=true"
import script from "./FollowAccount.vue?vue&type=script&lang=js"
export * from "./FollowAccount.vue?vue&type=script&lang=js"
import style0 from "./FollowAccount.vue?vue&type=style&index=0&id=34266906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34266906",
  null
  
)

export default component.exports